import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { TvShowTrackingTitleFragment } from '@/components/watchlist/graphql/fragments/TVShowTrackingTitle.fragment';

import WatchNowButtonNew from '@/components/buttons/WatchNowButtonNew.vue';
import TitleCardHeading from '@/components/list/title-card/TitleCardHeading.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';
import BasicTitleCardGraphql from '@/components/list/title-card/BasicTitleCardGraphql.vue';
import MarkAsSeenButtonView from '@/components/list/title-card/MarkAsSeenButton/MarkAsSeenButtonView.vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useProvideOfferEntityId } from '@/helpers/composables/useProvideClickoutPlacement';

import { computed, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCardShowEpisode',
  props: {
    title: { default: () => ({} as TvShowTrackingTitleFragment['node']) },
    saving: { type: Boolean },
    showUnseenEpisodeCount: { type: Boolean, default: true },
    showEpisodeName: { type: Boolean, default: true },
    showMarkAsSeenButton: { type: Boolean, default: true },
    additionalContexts: { default: () => [] }
  },
  emits: ["onPosterClick", "markAsSeen", "removeTitleFromList"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'onPosterClick', title: TvShowTrackingTitleFragment['node']): void;
	(e: 'markAsSeen'): void;
	(e: 'removeTitleFromList', objectId: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: TvShowTrackingTitleFragment['node'], saving?: boolean, showUnseenEpisodeCount: boolean, showEpisodeName: boolean, showMarkAsSeenButton: boolean, additionalContexts: SnowplowContext[] };





useProvideOfferEntityId(() => props.title.watchNextEpisode?.id);

const watchNextEpisode = computed(() => (props.title.__typename === 'Show' ? props.title.watchNextEpisode : null));
const fullPath = computed(() => watchNextEpisode.value?.season?.content.fullPath ?? props.title.content.fullPath);
const currentSeasonNumber = computed(() => watchNextEpisode.value?.content?.seasonNumber);
const currentEpisodeNumber = computed(() => watchNextEpisode.value?.content?.episodeNumber);
const cardHeading = computed(() =>
	watchNextEpisode.value ? `S${currentSeasonNumber.value} E${currentEpisodeNumber.value}` : ''
);
const episodeName = computed(() => watchNextEpisode.value?.content?.title);
const isShowCaughtUp = computed(() => (props.title.__typename === 'Show' ? props.title.seenState.caughtUp : false));
const unseenEpisodeLeft = computed(() => {
	const seenState = watchNextEpisode.value?.season?.seenState;
	return seenState ? seenState.releasedEpisodeCount - seenState.seenEpisodeCount - 1 : null;
});
const unseenEpisodeCountVisible = computed(() => {
	const unseenEpisodeAvailable = unseenEpisodeLeft.value
		? !!watchNextEpisode.value && unseenEpisodeLeft.value
		: false;
	return props.showUnseenEpisodeCount && unseenEpisodeAvailable;
});

watch(isShowCaughtUp, async newValue => {
	if (newValue) {
		TrackingHelper.trackEvent(
			'impression',
			{
				label: 'tv_show_tracking',
				action: 'caught_up_shown',
			},
			[
				TrackingHelper.getTitleContextGraphql(
					props.title.objectId,
					props.title.objectType,
					currentSeasonNumber.value,
					currentEpisodeNumber.value
				),
			]
		);

		await new Promise(resolve => setTimeout(resolve, 2500));
		emit('removeTitleFromList', props.title.objectId);
	}
});

return { __sfc: true,props, emit, watchNextEpisode, fullPath, currentSeasonNumber, currentEpisodeNumber, cardHeading, episodeName, isShowCaughtUp, unseenEpisodeLeft, unseenEpisodeCountVisible, WatchNowButtonNew, TitleCardHeading, TitleDetailLink, BasicTitleCardGraphql, MarkAsSeenButtonView }
}

})